import React from 'react'
import './CircleList.css'
import { Container,Row,Col } from 'react-bootstrap'
import AdminHeader from '../../components/adminHeader/AdminHeader'
import AdminSideBar from '../../components/adminSide/AdminSideBar'
import CircleTable from '../../components/circletable/CircleTable'

export default function CircleList() {
  return (
    <Container fluid>
    <Row>
    <Col xs={2}>
      <AdminSideBar/>
    </Col>
    <Col xs={10}>
      <AdminHeader />

      <CircleTable/>

    </Col>
    
    
    </Row>
    
        </Container>
  )
}
